import React from "react";
import EditProfile from "../../EditProfile/EditProfile";

export default function RegistrationInfoForm() {
  return (
    <div role="main">
      <p>
        Please enter the information that Utah's Office of Vital Records and Statitistics staff should use to contact
        you for questions or updates related to your registration.
      </p>
      <EditProfile nestedFormPrefix="registrantContactInfo" />
    </div>
  );
}
